import { render, staticRenderFns } from "./WhyGamefoundProjectExplorer.vue?vue&type=template&id=85dce654"
import script from "./WhyGamefoundProjectExplorer.vue?vue&type=script&lang=js"
export * from "./WhyGamefoundProjectExplorer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports